// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"473":"483239c8","500":"483239c8","841":"483239c8"}[chunkId] + ".chunk.css";
};